/** Every route string in the application originates here. */
export const paths = {
  root: '/',
  login: '/login',
  dashboard: '/dashboard',
  jobListings: {
    list: '/jobs',
    new: '/jobs/new',
    detail: '/jobs/:jobId',
    edit: '/jobs/:jobId/edit',
  },
  listingLeads: '/listing-leads',
  hiring: '/hiring',
  interviews: '/interviews',
  hired: '/hired',
  myPerformance: '/my-performance',
  inbox: '/inbox',
  meta: '/meta',
  metaExport: '/meta-export',
  bot: '/bot',
  screening: {
    list: '/screening',
    new: '/screening/new',
    edit: '/screening/:configId/edit',
  },
  blogs: {
    list: '/blogs',
    new: '/blogs/new',
    edit: '/blogs/:postId/edit',
  },
  users: '/users',
  designSystem: '/design-system',
  unauthorized: '/unauthorized',
}

export const screeningConfigEditPath = (configId) => `/screening/${configId}/edit`

export const blogPostEditPath = (postId) => `/blogs/${postId}/edit`

export const jobListingPath = (jobId) => `/jobs/${jobId}`
export const jobListingEditPath = (jobId) => `/jobs/${jobId}/edit`

/** Search-param key the login page uses to return people where they were. */
export const REDIRECT_PARAM = 'from'
